import { tOrder } from '@frontend/locales';

export const statusTypeMap = new Map([
  ['PENDING', tOrder.orderStatus.pending],
  ['CONFIRMED', tOrder.orderStatus.confirmed],
  ['READY', tOrder.orderStatus.ready],
  ['CLOSED', tOrder.orderStatus.closed],
  ['REJECTED', tOrder.orderStatus.rejected],
  ['REFUNDED', tOrder.orderStatus.refunded],
]);

export const deliveryOptionTypeMap = new Map([
  ['AT_COUNTER', tOrder.orderDeliveryOption.atCounter],
  ['TAKE_AWAY', tOrder.orderDeliveryOption.takeAway],
  ['EXTERNAL_DELIVERY', tOrder.orderDeliveryOption.externalDelivery],
  ['TO_TABLE', tOrder.orderDeliveryOption.toTable],
  ['TO_CAR', tOrder.orderDeliveryOption.toCar],
  ['SELF_SERVE', tOrder.orderDeliveryOption.selfService],
  ['INTRACITY', tOrder.orderDeliveryOption.intracity],
]);
